import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moTime from '../store/time';
import { e } from 'mathjs';
import { toJS } from 'mobx';

interface IProps { }
interface IState { }
let chart: any = null;

const TimeIncomeChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const industryRef = useRef<any>(null);
  const { timeTabActive, timeList } = moTime;

  const emen: any = {
    多指标: 'multi_indicator',
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
    元均营业收入: 'revenue_per_yuan',
    元均净利润: 'profit_per_yuan',
  };

  const xData = useMemo(() => {
    const active = emen[timeTabActive];
    const xList: any = [];
    const listp25: any = [];
    const listp50: any = [];
    const listp75: any = [];
    const listp50Ratio: any = [];
    if (!isEmpty(timeList)) {
      timeList[active]?.detail?.forEach((res: any) => {
        // list?.forEach((res: any) => {
        xList.push(res.label);
        if (res.p25 >= 0 && res.p50 >= 0 && res.p75 >= 0) {
          listp25.push(res.p25);
          listp50.push(res.p50 - res.p25);
          listp75.push(res.p75 - res.p50);
        }
        if (res.p25 < 0 && res.p50 >= 0 && res.p75 >= 0) {
          listp25.push(res.p25);
          listp50.push(res.p50);
          listp75.push(res.p75 - res.p50);
        }
        if (res.p25 < 0 && res.p50 < 0 && res.p75 >= 0) {
          listp25.push(res.p50);
          listp50.push(res.p25 - res.p50);
          listp75.push(res.p75 - res.p25 - res.p50);
        }
        if (res.p25 < 0 && res.p50 < 0 && res.p75 < 0) {
          listp25.push(res.p75);
          listp50.push(res.p50 - res.p75);
          listp75.push(res.p25 - res.p50);
        }
        listp50Ratio.push(res.p50_ratio);
      });
    }
    return {
      xList, listp25, listp50, listp50Ratio, listp75,
    };
  }, [timeList, timeTabActive]);

  const colorList = [Color.cf, Color.two, Color.primary, Color.secondary];

  const getRes = (val: any, i: number, parmes: any) => {
    let res = 0;
    const active = emen[timeTabActive];
    const list = timeList[active]?.detail;
    const ele = list.filter((item: any) => item.label === parmes);
    const element = ele[0];
    res = element[val[i]];
    return (timeTabActive === '元均营业收入' || timeTabActive === '元均净利润') ? round(res, 1).toLocaleString() : round(res, 0).toLocaleString();
  };

  const getColor25 = (val: any, n: any) => {
    let color = Color.whiteColor(0);
    if (val >= 0) {
      color = Color.whiteColor(0);
    }
    if (val < 0 && xData.listp50[n] > 0 && xData.listp75[n] > 0) {
      color = Color.two;
    }
    if (val < 0 && xData.listp50[n] < 0 && xData.listp75[n] > 0) {
      color = Color.primary;
    }
    if (val < 0 && xData.listp50[n] < 0 && xData.listp75[n] < 0) {
      color = Color.whiteColor(0);
    }
    return color;
  };

  const getColor50 = (val: any, n: any) => {
    let color = '';
    if (val < 0) {
      color = Color.two;
    }
    if (val > 0) {
      color = Color.two;
    }
    if (val < 0 && xData.listp75[n] < 0) {
      color = Color.primary;
    }
    return color;
  };

  const getColor75 = (val: any, n: any) => {
    let color = '';
    if (val < 0) {
      color = Color.two;
    } else {
      color = Color.primary;
    }
    return color;
  };

  const getfen25 = () => {
    const list = xData?.listp25?.map((res: any, r: any) => {
      const item: any = {
        value: res,
        itemStyle: {
          color: getColor25(res, r),
          borderWidth: 0,
        },
      };
      return item;
    });
    return list;
  };

  const getfen50 = () => {
    const list = xData?.listp50?.map((res: any, r: any) => {
      const item: any = {
        value: res,
        itemStyle: {
          color: (getColor50(res, r)),
        },
      };
      return item;
    });
    return list;
  };

  const getfen75 = () => {
    const list = xData?.listp75?.map((res: any, r: any) => {
      const item: any = {
        value: res,
        itemStyle: {
          color: (getColor75(res, r)),
        },
      };
      return item;
    });
    return list;
  };

  const render = () => {
    if (chart) chart.dispose();
    chart = init(industryRef.current);
    const option = {
      color: [Color.cf, Color.two, Color.primary, Color.secondary],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: { show: true },
        },
        formatter: (parmes: any) => {
          const data = ['25分位', '50分位', '75分位', '50分位变化率'];
          const data1 = ['p25', 'p50', 'p75'];
          let htl = `<p  style="font-family: 'PingFang SC'">${parmes[0].name}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                         justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${colorList[i]};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC'">${data[i]}</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';padding-top:4px;flex:1;text-align:right">
                        ${element.seriesType === 'line' ? (isNumber(element.value) ? `${round(element.value * 100, 1)}%` : '-') : (isNumber(element.value) ? getRes(data1, i, parmes[0].name) : '-')}
                      </span>
                   </p>`;
          });
          return htl;
        },
      },
      legend: {
        data: ['25-50分位', '50-75分位', '50分位变化率'],
        bottom: 0,
        icon: 'circle',
        selectedMode: false,
      },
      grid: {
        left: 30,
        right: 10,
        bottom: 45,
        top: 30,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xData.xList,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ccc },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
        },
      },
      yAxis: [
        {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: (val: number) => {
              if (val === 0) return 0;
              return `${Number(val).toLocaleString()}`;
            },
            fontSize: 10,
            color: Color.blackColor(0.5),
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: 'dashed',
            },
          },
        },
        {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          splitNumber: 5,
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: (val: number) => {
              if (val === 0) return 0;
              return `${round(Number(val) * 100, 0)}`;
            },
            fontSize: 10,
            color: Color.blackColor(0.5),
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: 'dashed',
            },
          },
        },
      ],
      series: [
        {
          name: '25分位',
          type: 'bar',
          barWidth: 20,
          stack: 'Total',
          data: getfen25(),
          itemStyle: {
            borderWidth: 0,
          },
        },
        {
          name: '25-50分位',
          type: 'bar',
          stack: 'Total',
          barWidth: 20,
          data: getfen50(),
        },
        {
          name: '50-75分位',
          type: 'bar',
          stack: 'Total',
          barWidth: 20,
          data: getfen75(),
        },
        {
          name: '50分位变化率',
          type: 'line',
          barWidth: 20,
          yAxisIndex: 1,
          label: {
            formatter(parmars: any) {
              return `${round(parmars.value * 100, 1)}%`;
            },
            show: true,
            fontFamily: 'Roboto',
            fontSize: '14px',
            color: Color.secondary,
          },
          data: xData.listp50Ratio,
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [timeList, timeTabActive]);

  return (
    <section className="industry-chart-warp" ref={industryRef} />
  );
};

export default observer(TimeIncomeChart);
